import '@angular/localize/init';
import 'classlist.js';
import 'core-js/stable/reflect';
import 'web-animations-js';
import 'zone.js';